import { createApiAction } from './common'

export const getDashboardAuthGroup = createApiAction('getDashboardAuthGroup')
export const putDashboardAuthGroup = createApiAction('putDashboardAuthGroup', (key) => ({ key }))
export const deleteDashboardAuthGroup = createApiAction('deleteDashboardAuthGroup', (key) => ({ key }))

//daily workout
export const getDailyWorkout = createApiAction('getDailyWorkout', (date) => ({date}))

